import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { responsive } from '@design-system/theme';
import { Title } from './Title';
import { getControlsWidth } from '../utils/getControlsWidth';
const Controls = ({ contentHeight, filteredControls, }) => {
    const containerRef = useRef(null);
    const [areButtonsVerticallyAlign, setAreButtonsVerticallyAlign] = useState(false);
    useLayoutEffect(() => {
        if (containerRef.current) {
            const containerWidth = containerRef.current.offsetWidth;
            const buttonsWidths = Array.from(containerRef.current.children).map((button) => button.offsetWidth);
            getControlsWidth({
                buttonsWidths,
                containerWidth,
                setAreButtonsVerticallyAlign,
            });
        }
    }, [filteredControls, contentHeight]);
    if (!filteredControls.length) {
        return null;
    }
    return (_jsx(ButtonsContainer, { "$areButtonsVerticallyAlign": areButtonsVerticallyAlign, ref: containerRef, children: filteredControls.map((control, index) => (_jsx(ButtonWrapper, { "$areButtonsVerticallyAlign": areButtonsVerticallyAlign, children: control }, index))) }));
};
export const Content = ({ contentHeight, description, filteredControls, maxWidthContent, showControls, showDescription, showPicture, title, widthContent, }) => {
    const descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split('\n');
    return (_jsx(ContentBox, { "$showPicture": showPicture, dataTestId: "appheader-content", height: contentHeight, children: _jsxs(Box, { flexDirection: "column", maxWidth: maxWidthContent, width: widthContent, children: [_jsx(Title, { title: title }), showDescription && (_jsx(Box, { font: "h4-regular", mt: "6px", title: description, children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map((paragraph, index) => (_jsx(DescriptionParagraph, { children: paragraph || '\u00A0' }, index))) })), showControls && (_jsx(Controls, { contentHeight: contentHeight, filteredControls: filteredControls }))] }) }));
};
const ContentBox = styled(Box).attrs(({ $showPicture }) => ({
    flexDirection: 'column',
    height: {
        l: 'auto',
    },
    justifyContent: {
        m: 'center',
    },
    px: { s: $showPicture ? 4 : 0, m: 0 },
    py: { s: $showPicture ? 6 : 0, m: 0 },
    width: $showPicture
        ? {
            l: 468,
            s: '100%',
            xl: '100%',
        }
        : undefined,
})) ``;
const DescriptionParagraph = styled.p `
  margin: 0;
`;
const ButtonsContainer = styled(Box).attrs(({ $areButtonsVerticallyAlign }) => ({
    display: 'flex',
    flexWrap: { s: 'wrap', m: $areButtonsVerticallyAlign ? 'wrap' : 'nowrap' },
    gap: 4,
    mt: 4,
})) ``;
const ButtonWrapper = styled(Box).attrs(({ $areButtonsVerticallyAlign }) => ({
    mr: { s: 0, m: $areButtonsVerticallyAlign ? 0 : 3 },
    width: { s: '100%', m: 'inherit' },
})) `
  & button {
    width: 100%;
    ${responsive('m') `
      width: auto;
    `}
  }

  &:last-child {
    margin-right: 0;
    margin-top: 12px;
    ${({ $areButtonsVerticallyAlign }) => responsive('m') `
      margin-top: ${$areButtonsVerticallyAlign ? '12px' : 0};
    `}
  }
`;
//# sourceMappingURL=Content.js.map